<template>
  <div class="cf-app-layout">
    <div class="cf-app-layout__header">
      <!-- App Header -->
      <cf-app-header :logo-navigation="{}">
        <template
          v-if="!isLoading"
          #header-left-slot
        >
          <cf-drop-down-menu-button hamburger-menu-type="PayAtTable" />
        </template>

        <template
          v-if="!isLoading && (isAccountManagementEnabled || isCartManagementEnabled)"
          #header-right-slot
        >
          <cf-sign-up-button v-if="isLoginEnabed" />

          <cf-sign-in-button v-if="isLoginEnabed && !metaFieldHideSignInButton" />

          <cf-account-button v-if="isAccountButtonDisplayed" />
        </template>
      </cf-app-header>
    </div>

    <!-- App Content -->
    <div class="cf-app-layout__main-content">
      <div
        v-if="isLoading"
        :class="['cf-container-full-width', { 'cf-page-loader': isLoading }]"
      >
        <div class="cf-loader" />
      </div>

      <template v-else>
        <router-view />
      </template>
    </div>

    <!-- App Footer -->
    <div class="cf-app-layout__footer">
      <cf-app-footer />
    </div>
  </div>
</template>


<script>
  import merchantInitializer from '@/mixins/merchant-initializer';

  import CfAppHeader from '@/view/components/globals/cf-app-header/index.vue';
  import CfAppFooter from '@/view/components/globals/cf-app-footer/index.vue';
  import CfDropDownMenuButton from '@/view/components/globals/cf-app-header/cf-drop-down-menu-button/index.vue';
  import CfSignInButton from '@/view/components/globals/cf-app-header/cf-sign-in-button/index.vue';
  import CfSignUpButton from '@/view/components/globals/cf-app-header/cf-sign-up-button/index.vue';
  import CfAccountButton from '@/view/components/globals/cf-app-header/cf-account-button/index.vue';


  export default {
    name: 'PayAtTableLayout',

    metaInfo() {
      const { merchant } = this;

      return {
        titleTemplate(titleChunk) {
          return titleChunk ? `${titleChunk} | Pay at Table | ${merchant.name}` : `Pay at Table | ${merchant.name}`;
        }
      };
    },

    components: {
      CfAppHeader,
      CfAppFooter,
      CfDropDownMenuButton,
      CfSignInButton,
      CfSignUpButton,
      CfAccountButton
    },

    mixins: [merchantInitializer],

    computed: {
      metaFieldHideSignInButton() {
        return this.$route.meta?.hideSignInButton;
      },

      metaFieldHideCartButton() {
        return this.$route.meta?.hideCartButton;
      },

      isLoading() {
        return this.isMerchantLoading;
      },

      isUserSignedIn() {
        return this.currentUser.accountId;
      },

      isAccountManagementEnabled() {
        return this.merchant.options.signUpEnabled;
      },

      isCartManagementEnabled() {
        return !this.merchant.features['disable-ordering'];
      },

      isLoginEnabed() {
        return this.isAccountManagementEnabled && !this.isUserSignedIn;
      },

      isAccountButtonDisplayed() {
        return this.isAccountManagementEnabled && this.isUserSignedIn;
      }
    },

    async created() {
      await this.initializeMerchant({
        defaultFulfillmentType: 'standard',
        defaultOrderType: 'pay',
        orderTypes: ['pay', 'table']
      });
    },

    unmounted() {
      this.destroyedMerchantHandler();
    }
  };
</script>
